module.exports = __webpack_public_path__ + "static/img/project-birli.6133025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-birli.png
// module id = NxjN
// module chunks = 0